import styled, { keyframes } from "styled-components";
import HeroTypewriterText, {
  HERO_COPY_TYPE_DELAY_MS,
} from "./HeroTypewriterText";
import { HeroTitle, heroLeadStyles } from "../styles/contentPage";

export { HERO_COPY_TYPE_DELAY_MS };

const heroTypingReveal = keyframes`
  0% {
    clip-path: inset(0 100% 0 0);
    opacity: 0.72;
    filter: blur(0.6px);
  }

  55% {
    opacity: 1;
    filter: blur(0);
  }

  100% {
    clip-path: inset(0 0 0 0);
    opacity: 1;
    filter: blur(0);
  }
`;

const heroTypingCaret = keyframes`
  0% {
    left: 0;
    opacity: 0;
  }

  9%, 84% {
    opacity: 0.72;
  }

  100% {
    left: 100%;
    opacity: 0;
  }
`;

const heroCopyCursorBlink = keyframes`
  0%, 48% {
    opacity: 0.82;
  }

  49%, 100% {
    opacity: 0.18;
  }
`;

export const HeroTypingTitle = styled(HeroTitle)`
  position: relative;
  width: fit-content;
  max-width: 100%;
  overflow: hidden;
  animation: ${heroTypingReveal} 1.38s cubic-bezier(0.2, 0.72, 0.12, 1) 0.1s both;
  will-change: clip-path, opacity;

  &::after {
    content: "";
    position: absolute;
    top: 0.08em;
    bottom: 0.04em;
    width: 2px;
    border-radius: 999px;
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0),
      rgba(255, 255, 255, 0.88),
      rgba(255, 255, 255, 0)
    );
    box-shadow: 0 0 16px rgba(200, 238, 248, 0.38);
    animation: ${heroTypingCaret} 1.38s cubic-bezier(0.2, 0.72, 0.12, 1) 0.1s both;
    pointer-events: none;
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none !important;

    &::after {
      display: none;
    }
  }
`;

export const HeroTypingLead = styled(HeroTypewriterText)`
  ${heroLeadStyles}
  position: relative;

  [data-typewriter-measure]::before {
    content: attr(data-typewriter-full);
  }

  [data-typewriter-cursor] {
    display: inline-block;
    width: 2px;
    height: 1.1em;
    margin-left: 3px;
    border-radius: 999px;
    transform: translateY(0.14em);
    background: rgba(255, 255, 255, 0.74);
    box-shadow: 0 0 14px rgba(200, 238, 248, 0.34);
    animation: ${heroCopyCursorBlink} 0.86s steps(1, end) infinite;
  }

  @media (prefers-reduced-motion: reduce) {
    [data-typewriter-cursor] {
      display: none;
      animation: none !important;
    }
  }
`;
